module.exports = __webpack_public_path__ + "img/pic_bg3.a300c5a6.jpg";